// extracted by mini-css-extract-plugin
module.exports = {"footer":"RequestEmailChangeModal_footer__3YSxI","label":"RequestEmailChangeModal_label__3B09d"};